export const SELLER_INVOICES_PAGE = 'seller-invoices-page';
export const REGISTER_LAYOUT_HEADER_MIGRATION =
  'supply_seller_ui_header_migration';
